export default [
  {
    text: 'Label',
    value: 'label',
    width: '260px',
    order: 0,
    sortable: true,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Placeholder',
    value: 'placeHolder',
    align: 'left',
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Color',
    value: 'color',
    align: 'left',
    sortable: false,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Field Type',
    value: 'fieldType',
    align: 'left',
    sortable: false,
    order: 4,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Enable',
    value: 'isEnabled',
    align: 'left',
    sortable: false,
    order: 5,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Grid Visibility',
    value: 'isVisible',
    align: 'left',
    sortable: false,
    order: 5,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    align: 'right',
    sortable: false,
    order: 6,
    hidable: true,
    hidden: false,
    width: '92px',
  },
];
